import { NSARouterMakerResult } from "namirasoft-account-react";
import { BaseMetaColumn, IStorageLocal } from "namirasoft-core";
import { NamirasoftERPMetaDatabase } from "namirasoft-erp";
import { NamirasoftMap } from "namirasoft-site-map";
import { BaseColumnFormatter, IDFormatter, NSColumn, NSTable, NSTitle, TableColumnInfo } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { ErpRouterProps } from "../ErpRouterProps";

export interface FiscalYearBranchRow
{
    id: string;
    user_id: string;
    fiscal_year_id: string;
    branch_id: string;
    opening_journal_entry_id: string | null;
    closing_journal_entry_id: string | null;
}

interface FiscalYearBranchesViewProps extends NSARouterMakerResult, ErpRouterProps
{
    fiscal_year_id: string;
    rows: FiscalYearBranchRow[];
}

interface FiscalYearBranchesViewState
{
    columns: TableColumnInfo[] | null;
}

export class FiscalYearBranchesView extends Component<FiscalYearBranchesViewProps, FiscalYearBranchesViewState>
{
    override state: FiscalYearBranchesViewState = { columns: null };

    private Table_Ref = createRef<NSTable<FiscalYearBranchRow>>();

    override componentDidMount(): void { this.setState({ columns: this.buildColumns() }); }

    override componentDidUpdate(prev: FiscalYearBranchesViewProps): void
    {
        if (prev.fiscal_year_id !== this.props.fiscal_year_id || prev.rows !== this.props.rows)
            this.Table_Ref.current?.reload(null, null);
    }

    private buildColumns(): TableColumnInfo[]
    {
        let db = new NamirasoftERPMetaDatabase(this.props.account.token_manager, console.error);
        let namirasoft = new NamirasoftMap(this.props.account.token_manager, console.error);
        let table = db.tables.fiscal_year as any;
        let branch_id_col = new BaseMetaColumn(table, "branch_id", "Branch", db.tables.branch.columns.id.type, true);
        let opening_col = new BaseMetaColumn(table, "opening_journal_entry_id", "Opening Journal Entry", db.tables.journal_entry.columns.id.type, false);
        let closing_col = new BaseMetaColumn(table, "closing_journal_entry_id", "Closing Journal Entry", db.tables.journal_entry.columns.id.type, false);
        return [
            BaseColumnFormatter.getColumn(branch_id_col, new IDFormatter(namirasoft, new IStorageLocal())),
            BaseColumnFormatter.getColumn(opening_col, new IDFormatter(namirasoft, new IStorageLocal())),
            BaseColumnFormatter.getColumn(closing_col, new IDFormatter(namirasoft, new IStorageLocal())),
        ];
    }

    private getRows = async (): Promise<{ rows: FiscalYearBranchRow[], count: number }> =>
    {
        let rows = this.props.rows ?? [];
        return { rows, count: rows.length };
    };

    override render()
    {
        let { columns } = this.state;
        return (
            <NSColumn style={{ width: "100%", marginTop: 16, gap: 8 }}>
                <NSTitle title="Branches" />
                <div style={{ display: "flex", flexDirection: "column", gap: 8, width: "100%", flexGrow: 1 }}>
                    <NSTable<FiscalYearBranchRow>
                        ref={this.Table_Ref}
                        name="fiscal-year-branches"
                        checkbox={false}
                        columns={columns ?? this.buildColumns()}
                        getRows={this.getRows}
                        getRowKey={(row) => row.value.id}
                        ui={{ pagination: false, button_panel: false }}
                    />
                </div>
            </NSColumn>
        );
    }
}